import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { Avatar, AvatarGroup, Box, Button, Grid, Skeleton, Stack, Typography } from "@mui/material"
import { ComputeDays, ComputePercentage, GetAverageResult, GetPercentageFormat } from "../../../../toolUsage/global/Format"
import { ToolListShuffle } from "../../../../toolUsage/usageOverview/accessTools/ToolListShuffle"
import { GraphBarIcons, QuestionMarkIcons } from "../../../../toolUsage/global/Icons"
import { GetToolUsage, GetToolUsagePercentage } from "../../../../global/API"
import { FeatureState, FetchingGraphDates } from "../../../../toolUsage/global/GlobalFcn"
import moment from "moment"

export const ToolSummary = ({ts}) => {

    const nav = useHistory()
    const { toolOwned, toolShuffle, __SESSION } = ts

    const [toolSummary, setToolSummary] = useState([
        {id:1, title:'Usage Access Percentage', percentage:0, loader:false, color:'#5DB55D', bgcolor:'#F2FFF2', path:'/profile?tabs=usage-overview'},
        {id:2, title:'Usage Awareness', percentage:0, loader:false, color:'#F6C915', bgcolor:'#FFF9E1', path:'/profile?tabs=usage-overview'},
        // {id:3, title:'Task Rate', percentage:0, loader:false, color:'#FFA54B', bgcolor:'#FFF8F1', path:'/profile?tabs=daily-task'},
    ]) 

    const currentDate = new Date();
    const previousDate = new Date(currentDate);
    previousDate.setDate(previousDate.getDate() - 3); // GET PREVIOUS DATE 4 DAYS

    const fetchToolUsage = async(tid, role_id) => {
        let qsp = {
            tool_id:tid,
            role_id:role_id || 0,
            platform:'business'
        }
        let res = await GetToolUsage(qsp)
        return res
    }

    // FOR USAGE ACCESS PERCENTAGE
    const getUsageAccessPerTool = async(tid, start_date, last_date) => {
        let qsp = {
            company_id:__SESSION.data.uaccess[0]?.company_id || 0,
            tool_id:tid,
            user_id:parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]),
            date_from:start_date,
            date_to:last_date
        }
        
        let res_data = await GetToolUsagePercentage(qsp)
        return res_data
    }
    
    const getThresholdPerTool = async(tid, role_id) => {
        let res = await fetchToolUsage(tid, role_id)
        return res.length > 0 ? res[0].features.map(v => { return { feature_id:v.tool_feature_id, feature_name:v.name, value:v.usage_threshold } }) : res
    }    

    const getUsageAccess = async() => {
        let res_dates = await FetchingGraphDates('daily', 4, 'desc', moment(new Date()).format("MM-DD-YYYY"), '1st')
      
        setToolSummary(prev =>
            prev.map(v =>
                v.id === 1 ? { ...v, loader:true } : v
            )
        );

        if (toolOwned.data) {            
        // if (toolOwned.data.length > 0) {  // IF OKAY NA ANG BUSINESS MODEL        
            let res_data = toolOwned.data.map(v => { return { tid:v.tid, name:v.name, description:v.description, logo:v.logo, role_id:v.role_id } })
            if (res_data.length > 0) {
                
                for (let i = 0; i < res_data.length; i++) {
                    // let res_threshold = await getThresholdPerTool(res_data[i].tid, res_data[i].role_id)
                    let resthreshold = await getThresholdPerTool(res_data[i].tid, res_data[i].role_id)
                    let res_threshold = resthreshold.filter(f => {return f.value > 0})
                    let res_data_count = await getUsageAccessPerTool(res_data[i].tid, res_dates.start_date, res_dates.last_date)
                  
                    let res_compute_days = await ComputeDays(res_dates.start_date, res_dates.last_date)
    
                    const combineArray = res_threshold?.map((rt) => {
                        const rdc = res_data_count.find((rdc) => rt.feature_id === rdc.feature_id); 
                        // const rdc = res_data_count.find((rdc) => rt.feature_id === rdc.feature_id && rt.feature_name === rdc.feature_name); 
                        return { formula:'count / value * 100', count:rdc?.count || 0, value:(rt.value || 0) * res_compute_days, usage:rdc? ComputePercentage(rdc.count, (rt.value || 0) * res_compute_days) : 0}; 
                    });
                  
                    const averageUsage = combineArray?.reduce((sum, item) => sum + parseFloat(item.usage), 0) / combineArray?.length
                    res_data[i] = {...res_data[i], usage:GetPercentageFormat(Math.ceil(averageUsage) || 0)}
                }
                
                const totalAverageUsage = res_data?.reduce((sum, item) => sum + parseFloat(item.usage), 0) / res_data?.length
                if (totalAverageUsage || totalAverageUsage === 0) {
                    setToolSummary(prev =>
                        prev.map(v =>
                            v.id === 1 ? { ...v, percentage:GetPercentageFormat(totalAverageUsage) || 0, loader:false } : v
                        )
                    );
                }
            }
        }
    } 

    // FOR USAGE AWARENESS
    const fetchToolUsageThreshold = async() => { 
        let res_target = await fetchToolUsage(parseInt(process.env.REACT_APP_TID), __SESSION.data.uaccess[0]?.role_id)
        if (res_target) {
            let role_type = __SESSION.data.uaccess[0]?.role_name
            let ftrdata = await FeatureState('all', role_type) || console.log('Feature Name is Not Found!')
            if (ftrdata) {
                let res_ftlr_data = ftrdata?.map(v => {return {feature_id:v.id, feature_name:v.feature_name, path:v.path } })
    
                const combineArray = res_ftlr_data?.map((rfd) => {
                    const rt = res_target[0]?.features.find((rt) => rfd.feature_id === rt.tool_feature_id && rfd.feature_name === rt.name); 
                    return {...rfd, usage_threshold:rt?.usage_threshold || 0, tool_pages:rt?.tool_pages || 0};
                });
    
                return {
                    feature_data:combineArray
                }
            }
        }
    }

    const getUsageAwareness = async() => {
       
        setToolSummary(prev =>
            prev.map(v =>
                v.id === 2 ? { ...v, loader:true } : v
            )
        );
        
        if (toolOwned.data) {
        // if (toolOwned.data.length > 0) { // IF OKAY NA ANG BUSINESS MODEL   
            const res_target = await fetchToolUsageThreshold()
            if (res_target) {
                let res_dates = await FetchingGraphDates('daily', 4, 'desc', moment(new Date()).format("MM-DD-YYYY"), '1st')
                let role_type = __SESSION.data.uaccess[0]?.role_name || ''
                let ftrdata = await FeatureState('all', role_type) || console.log('Feature Name is Not Found!')

                if (ftrdata) {
                    let res_ftlr_data = ftrdata?.map(v => {return {feature_id:v.id, feature_name:v.feature_name, path:v.path } })
                    let res_compute_days = await ComputeDays(res_dates.start_date, res_dates.last_date)
                    const combineArray = res_ftlr_data?.map((rfd) => {
                        const rt = res_target.feature_data.find((rt) => rfd.feature_id === rt.feature_id && rfd.feature_name === rt.feature_name); 
                        return {...rfd, value:rt?.usage_threshold * res_compute_days || 0};
                    });
                    let res_threshold = combineArray.filter(f => {return f.value > 0})
                    let qsp = {
                        company_id:__SESSION.data.uaccess[0]?.company_id,
                        tool_id:parseInt(process.env.REACT_APP_TID),
                        user_id:parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]),
                        date_from:res_dates.start_date,
                        date_to:res_dates.last_date,
                    }
                    
                    let res_data = await GetToolUsagePercentage(qsp)
                    
                    const finalArray = res_threshold?.map((ca) => {
                        const rdc = res_data?.find((rdc) => ca.feature_id === rdc.feature_id && ca.path === rdc.path); 
                        return {...ca, usage:rdc? ComputePercentage(rdc.count, ca.value) : 0};
                    });
                    
                    const averageUsage = finalArray?.reduce((sum, item) => sum + parseFloat(item.usage), 0) / finalArray?.length
                    setToolSummary(prev =>
                        prev.map(v =>
                            v.id === 2 ? { ...v, percentage:GetPercentageFormat(Math.ceil(averageUsage)) || 0, loader:false } : v
                        )
                    );
                }
            }
        }
    }
    
    const __init = async() => {
        await getUsageAccess()
        await getUsageAwareness()
    }

    useEffect(() => {
        __init()
        // eslint-disable-next-line
    },[toolOwned.data])

    return (
        <Box height="358px" width="100%" display="flex" flexDirection="column" gap="16px">
            <Box minHeight="19px" display="flex" alignItems="center" gap="12px">
                <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%">My Business Tool Summary</Typography>
                <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%" color="#5DB55D">Info</Typography>
            </Box>
            <Grid container sx={{height:'171px'}} spacing="16px">
                {toolSummary?.map((v,k) => (
                    <Grid key={k} item xs={3} height="100%">
                        <Button onClick={()=> nav.push(v.path)} sx={{
                            height:'100%',
                            width:'100%',
                            border:`1px solid ${v.color}`,
                            borderRadius:"12px",
                            bgcolor:v.bgcolor,
                            p:'24px',
                            display:'flex',
                            flexDirection:'column',
                            justifyContent:'flex-start',
                            alignItems:'flex-start',
                            gap:'12px',
                            ':hover':{bgcolor:v.bgcolor}
                        }} 
                        >
                            <Box minHeight="20px" minWidth="20px"><GraphBarIcons/></Box>
                            <Stack width="100%" gap="4px" textAlign="left">
                                <Stack direction="row" alignItems="center" gap="12px">
                                    <Typography fontWeight={600} fontSize={14} lineHeight="120%" letterSpacing="-0.75%" color="#292C2F">{v.title}</Typography>
                                    <QuestionMarkIcons/>
                                </Stack>
                                {v.loader ? 
                                    <Stack direction="row" alignItems="center" gap="12px">
                                        <Skeleton variant="rectangular" height="37px" width="20px" sx={{borderRadius: '6px'}} />
                                        <Skeleton variant="rectangular" height="37px" width="60px" sx={{borderRadius: '12px'}} />
                                    </Stack>
                                :
                                    <Stack direction="row" alignItems="center" gap="12px">
                                        <Typography fontWeight={600} fontSize={28} lineHeight="132%" letterSpacing="-1%" color="#292C2F">{v.percentage}</Typography>
                                        <Box height="26px" p="4px 12px 4px 12px" bgcolor={v.color} borderRadius="12px">
                                            <Typography fontWeight={400} fontSize={12} lineHeight="147%" letterSpacing="0%" color={v.bgcolor}>{GetAverageResult(v.percentage)}</Typography>
                                        </Box>
                                    </Stack>
                                }
                                <Typography fontWeight={400} fontSize={12} lineHeight="147%" letterSpacing="0%" color={v.color}>{moment(previousDate).format('MMM DD')}-{moment(new Date()).format('DD, YYYY')}</Typography>
                            </Stack>

                        </Button>
                    </Grid>
                ))}
                <Grid item xs={3} height="100%">
                    <Stack height="100%" border="1px solid #D6D9DB" borderRadius="12px" p="24px" bgcolor="#FFFFFF" gap="16px">
                        <GraphBarIcons/>
                        <Typography fontWeight={600} fontSize={14} lineHeight="120%" letterSpacing="-0.75%" color="#292C2F">Total Accessed Tools</Typography>
                        <Stack direction="row" alignItems="center" gap="12px">
                            <AvatarGroup>
                                {toolShuffle.data.map((v, k) => (
                                    <Avatar key={k} sx={{height:24, width:24, zIndex:k, border:'1px solid #FFFFFF'}} alt="Remy Sharp" src={JSON.parse(v.logo)} />
                                ))}
                            </AvatarGroup>
                            <Typography fontWeight={600} fontSize={28} lineHeight="132%" letterSpacing="-1%" color="#292C2F">{toolOwned.data.length}</Typography>
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>
            <ToolListShuffle/>
        </Box>
    )
}